/// <amd-module name="DistributedTaskUI/SecurityComponent/UserPermissionsAuthorization/Actions/RoleAssignmentComponentSecurityActionsCreator" />
import Roles_Contracts = require("SecurityRoles/Client/Contracts/SecurityRoles");
import { RoleAssignmentComponentSecurityActionsHub } from "UserPermissionsAuthorization/Actions/RoleAssignmentComponentSecurityActionsHub";
import { RoleAssignmentComponentSecuritySource } from "UserPermissionsAuthorization/Source/RoleAssignmentComponentSecuritySource";
export class RoleAssignmentComponentSecurityActionsCreator {

    constructor(actions: RoleAssignmentComponentSecurityActionsHub, resourceId: string, scopeId: string, endpointId: string, source: RoleAssignmentComponentSecuritySource) {
        this._actions = actions;
        this._resourceId = resourceId;
        this._scopeId = scopeId;
        this._source = source;
    }

    public initialize(): void {
        this._source.getRoleDefinitions(this._scopeId).then((roleDefinitions: Roles_Contracts.SecurityRole[]) => {
            this._actions.initializeRoles.invoke(roleDefinitions);
        });

        this._source.getRoleAssignments(this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
            this._actions.initializeRoleAssignments.invoke(roleAssignments);
        });

    }

    public tryAddUser = (roleRefs: Roles_Contracts.UserRoleAssignmentRef[]): Promise<void> => {
        return this._source.setRoleAssignments(roleRefs, this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
                this._actions.addNewUser.invoke(roleAssignments);

        }, (error) => {
            this.setErrorMessage(error.message);
        });
    }

    public beginSave(changedRoleAssignments: Roles_Contracts.UserRoleAssignmentRef[], removedUserIds: string[]): Promise<boolean> {
        return this._source.beginSave(changedRoleAssignments, this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
            return this._source.removeRoleAssignments(removedUserIds, this._scopeId, this._resourceId).then(() => {
                this._source.getRoleAssignments(this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
                    this._actions.initializeRoleAssignments.invoke(roleAssignments);
                });

                return true;
            });
        });
    }

    public changeInheritance(enableInheritance: boolean): void {
        this._source.changeInheritance(this._scopeId, this._resourceId, enableInheritance).then(() => {
            this._source.getRoleAssignments(this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
                this._actions.initializeRoleAssignments.invoke(roleAssignments);
            });
        });
    }

    public changeScope(_resourceId: string, roleScope: string, scopeId: string): void {
        this._actions.updateRoleScope.invoke(roleScope);
        this._scopeId = scopeId;
        this._resourceId = _resourceId;
        this._source.getRoleDefinitions(this._scopeId).then((roleDefinitions: Roles_Contracts.SecurityRole[]) => {
            this._actions.initializeRoles.invoke(roleDefinitions);
        });
        this._source.getRoleAssignments(this._scopeId, this._resourceId).then((roleAssignments: Roles_Contracts.RoleAssignment[]) => {
            this._actions.initializeRoleAssignments.invoke(roleAssignments);
        });
    }

    public setErrorMessage(errorMessage: string): void {
        this._actions.setErrorMessage.invoke(errorMessage);
    }

    public _actions: RoleAssignmentComponentSecurityActionsHub;
    public _resourceId: string;
    public _scopeId: string;
    public _source: RoleAssignmentComponentSecuritySource;
}
